var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"text-align":"left"}},[_c('label',{staticClass:"label"},[_vm._v("Beschreibung")]),_c('VueTrix',{attrs:{"maxlength":"255","placeholder":"Beschreibung einfügen"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }